import { render, staticRenderFns } from "./userDetail.vue?vue&type=template&id=2f0fcf73&scoped=true"
import script from "./userDetail.vue?vue&type=script&lang=js"
export * from "./userDetail.vue?vue&type=script&lang=js"
import style0 from "./userDetail.vue?vue&type=style&index=0&id=2f0fcf73&prod&lang=css"
import style1 from "./userDetail.vue?vue&type=style&index=1&id=2f0fcf73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0fcf73",
  null
  
)

export default component.exports